"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CJOnePointIntroResponseSchema = exports.CjOnePointIntroStatus = void 0;
var zod_1 = require("zod");
exports.CjOnePointIntroStatus = {
    CONNECTED: 'CONNECTED',
    TERM_NOT_AGREED: 'TERM_NOT_AGREED',
    NOT_CERTIFICATED_MEMBER: 'NOT_CERTIFICATED_MEMBER',
};
exports.CJOnePointIntroResponseSchema = zod_1.z.object({
    connectStatus: zod_1.z.union([
        zod_1.z.literal(exports.CjOnePointIntroStatus.CONNECTED),
        zod_1.z.literal(exports.CjOnePointIntroStatus.TERM_NOT_AGREED),
        zod_1.z.literal(exports.CjOnePointIntroStatus.NOT_CERTIFICATED_MEMBER),
    ]),
});
